'use client';

import { SvgLoader } from '@/app/elements/svg/loader';

import './styles/default.scss';

type PopupHeaderProps = {
    onClose: () => void;
    exclusiveLogo?: string;
};

export const PopupHeader: React.FC<PopupHeaderProps> = ({ onClose, exclusiveLogo }) => {
    return (
        <>
            <button className="exclusive-modal-component__close-button" onClick={onClose} aria-label="Close modal">
                <SvgLoader iconName="exclusive-close-button" width="44" height="44" />
            </button>

            {exclusiveLogo && (
                <img className="exclusive-modal-component__logo" alt="exclusive logo" src={exclusiveLogo} />
            )}
        </>
    );
};
